// extracted by mini-css-extract-plugin
module.exports = {"icon-btn":"icon-btn","icon":"icon"};